import React, { useContext, useEffect, useState } from 'react'
import API from '../../services/API'
import moment from 'moment'
import { Button, Stack, Typography } from '@mui/material'
import SmallModal from '../../components/Modals/SmallModal'
import AnDateField from '../../components/DateTime/DateField'
import { GlobalContext } from '../../App'

const AddNewEngagementLetterPopup = ({
  open,
  onClose,
  clientName,
  clientID,
}) => {
  const [startDate, setStartDate] = useState(moment())
  const [endDate, setEndDate] = useState(moment().add(1, 'year'))
  const { setToast } = useContext(GlobalContext)
  const handleEngagementLetterSubmit = (e) => {
    e.preventDefault()
    API.post('/clients/engagement-letter', {
      clientID,
      clientName,
      startDate,
      endDate,
    }).then((res) => {
      if (res.status === 200) {
        onClose()
        setToast({ message: 'Engagement Letter Created' })
      }
    })
  }

  useEffect(() => {
    setStartDate(moment())
    setEndDate(moment().add(1, 'year'))
  }, [open])
  return (
    <SmallModal open={open} onClose={onClose}>
      <Stack gap={2} component="form" onSubmit={handleEngagementLetterSubmit}>
        <Typography variant="title2" fontSize="1rem" textAlign="center">
          Create engagement letter for {clientName}
        </Typography>
        <AnDateField
          date={startDate}
          onChange={(newDate) => setStartDate(newDate)}
          label="Start Date"
          size="small"
          required
        />
        <AnDateField
          date={endDate}
          onChange={(newDate) => setEndDate(newDate)}
          label="End Date"
          size="small"
          required
        />
        <Button fullWidth variant="contained" color="success" type="submit">
          Submit
        </Button>
      </Stack>
    </SmallModal>
  )
}

export default AddNewEngagementLetterPopup
